export const CONVERSATION_MODEL = "conversation";

const conversationModel = {
  conversationFormat: "",
  subject: "",
  body: "",
  isOpen: false,
  relatedToType: "",
  relatedToId: "",
  relatedToDescription: "",
  recipientId: "",
  recipientType: "",
  attachments: [],
  recipientName: "",
  messages: {
    jsonApi: "hasMany",
    type: "conversation-messages"
  },
  lastMessage: {
    jsonApi: "hasOne",
    type: "conversation-messages"
  },
  recipient: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default conversationModel;
